import {TimelineLite} from "gsap";
import {GGGameModuleConfig} from "../GGGameModuleConfig";
import {GGReelSymbolM} from "../symbols/GGReelSymbolM";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class PatchEvil4Multiplier extends BaseView {

    constructor() {
        super();
    }
    public showEvil4Multipliers(syms:string[], evil4Sym:string, evil4Multiplier:number, totalNumberOfWays:number):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        let hasEvil4Symbol:boolean = false;
        syms.forEach((sym:string, i:number)=>{
            if(sym===evil4Sym){
                hasEvil4Symbol = true;
               timeline.add(this.showEvil4Multiplier(Reels.getSymbol(0, i)!, evil4Multiplier), 0);
            }
        });
        if(hasEvil4Symbol){
            GGGameModuleConfig.betWaysOnReel.updateBetWays(totalNumberOfWays);
        }
        return timeline;
    }
    private showEvil4Multiplier(sym:StateReelSymbol, evil4Multiplier:number):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
            const symbol:GGReelSymbolM = <GGReelSymbolM>sym;
            if(symbol == null) {
                debugger;
                throw new Error(`Evil4.startWinPresentation(): Cannot find symbol at reelId = ${0}, symbolId = ${sym.symName}.`);
            }
            timeline.add(symbol.patchMultiplier(evil4Multiplier, true));

        return timeline;
    }
}